"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const common_components_1 = require("@zapier/common-components");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        'p:last-child': {
            marginBottom: 0,
        },
        a: {
            textDecoration: 'underline',
        },
    },
});
const CopyField = ({ help_text_html, help_text, }) => {
    return help_text_html ? (common_utils_1.isolateComponent(common_components_1.MessageBar, { type: "info" },
        common_utils_1.isolateComponent("div", { css: Styles.root, dangerouslySetInnerHTML: { __html: help_text_html } }))) : (common_utils_1.isolateComponent(common_components_1.MessageBar, { type: "info" }, help_text));
};
exports.default = CopyField;
